export default "__VITE_ASSET__BqoYRcNG__"